import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NotaryFileType } from 'Pages/lead'
import { RequestParams } from 'Models'
import { NotificationMessageModel } from 'Modules'

export namespace LeadActionsNS {
	export type DownloadFile = PayloadAction<{
		id: number
		type: NotaryFileType
		name: string
	}>
	export type SendReport = PayloadAction<RequestParams>
	export type PushLeadSocketId = PayloadAction<{
		id: number
		fio: string
		notify?: NotificationMessageModel
		inn?: string
	}>
	export type RefreshSmsRbidosLead = PayloadAction<number>
}

export const leadActionsSlice = createSlice({
	name: 'leadActions',
	initialState: {},
	reducers: {
		downloadFile: (state, action: LeadActionsNS.DownloadFile) => {},
		sendReport: (state, action: LeadActionsNS.SendReport) => {},
		refreshSmsRbidosLead: (state, action: LeadActionsNS.RefreshSmsRbidosLead) => {},
		pushLeadSocketId: (state, action: LeadActionsNS.PushLeadSocketId) => {},
	},
})
